export default __webpack_public_path__ + "static/media/leaf7.efba0724.svg";